<template>
    <footer class="home-footer">
        <div class="home-footer-con">
            <div class="home-footer-con-img" style="position:relative">
                <img src="@p/assets/images/icon/logo-footer.png" alt="logo">
                <span class="version">BETA {{releaseNumber}}</span>
            </div>
            <div class="home-footer-con-about">
                <div class="home-footer-nav">
                    <h2 class="p-pointer" :class="{'active-h2':$route.name === 'about'}"  @click="$store.commit('setBreadcrumb','');;$router.push({path:'/home/about',query:{title:'關於我們'}})">關於我們</h2>
                </div>
                <p>Copyright © 2020 LMS{{bottomNumber}}</p>
            </div>
            <span class="p-pointer" style="color:#fff"><i class="el-icon-question"></i> 幫助</span>
        </div>
    </footer>
</template>
<script>
import config from '@/config'
export default {
    data(){
        return {
            releaseNumber: config.releaseNumber,
            bottomNumber: config.bottomNumber
        }
    },
    methods:{

    }
}
</script>
<style lang="less" scoped>
@sectionCon:1200px;

.home-footer{
    height: 121px;
    background: #4D8EF6;
    &-con{
        width: @sectionCon;
        margin: 0 auto;
        display: flex;
        align-items: center;
        height: 100%;
        &-img{
            width: 70px;
            height: 54px;
            img{
                display: block;
            }
            .version{
                color: #fff;
                font-size: 12px;
                width: 70px;
                top: 45px;
                position: absolute;
            }
        }
        &-about{
            margin: 0 auto;
            color: #ffffff;
            text-align: center;
            padding-right: 54px;
            margin-top: 20px;
            h2{
                font-size: 18px;
                margin-bottom: 17px;
                font-weight:400;
                width: 120px;
                height: 40px;
                line-height: 40px;
                background:rgba(255,255,255,0.26);
                margin-left: 13px;
                &:hover{
                    background: #ffffff;
                    color: #4D8EF6;
                }
            }
            p{
                font-size:12px;
            }
        }
    }
    &-nav{
        display: flex;
        ul{
            display: flex;
            li{
                padding: 0 30px;
                color:rgba(255,255,255,0.60);
                font-size: 14px;
                position: relative;
                line-height: 45px;
            }
            li:before{
                border-right:1px solid rgba(255,255,255,0.2);
                position: absolute;
                height: 14px;
                right: 0;
                top: 17px;
                content:'',
            }
            li>span:hover{
                color: #ffffff;
            }
            li:last-child:before{
                border: 0 ;
            }
        }
    }
    .active-h2{
        background: #ffffff;
        color: #4D8EF6;
    }
}
</style>